/* global svg4everybody */
import objectFitImages from 'object-fit-images'

// Site-wide JS functionality

// Callback to fire when DOM loaded:
var ready = function () {
  // Polyfill images using object-fit in unsupported browsers.
  // See: https://github.com/fregante/object-fit-images
  objectFitImages()

  // Init all Vue components:
  require('./vue-root')
  require('./phone-validation')
  require('./address-search')
  require('./login-page')
  require('./password-validator')
  try {
    svg4everybody()
  } catch (error) {
    console.error(error)
  }
}

// Check if DOM ready:
if (document.readyState === 'complete' || (document.readyState !== 'loading' && !document.documentElement.doScroll)) {
  ready()
} else {
  document.addEventListener('DOMContentLoaded', ready)
}
